import { render, staticRenderFns } from "./Shipping2.vue?vue&type=template&id=1788488e&scoped=true"
import script from "./Shipping2.vue?vue&type=script&lang=js"
export * from "./Shipping2.vue?vue&type=script&lang=js"
import style0 from "./Shipping2.vue?vue&type=style&index=0&id=1788488e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788488e",
  null
  
)

export default component.exports